import React from 'react'
import dynamic from 'next/dynamic'

import { BreakpointSizes } from 'src/types/device'
import { useDevice } from 'src/hooks/useDevice'

const LogoSquare = dynamic(() => import('client/components/LogoBrand/LogoSquare'))
const LogoWide = dynamic(() => import('client/components/LogoBrand/LogoWide'))

interface ILogoBrand {
  isPrime: boolean
  isPromo: boolean
  isResponsive: boolean
}

const LogoBrand = ({ isPrime = false, isPromo = false, isResponsive = false }: ILogoBrand) => {
  const { activeBreakpoint } = useDevice()
  if (isResponsive && activeBreakpoint < BreakpointSizes.M) {
    return <LogoSquare isPrime={isPrime} isPromo={isPromo} />
  }

  return <LogoWide isPrime={isPrime} isPromo={isPromo} isResponsive={isResponsive} />
}

export default LogoBrand
